// src/components/cierreGeneral/TopClients.jsx
import React, { useMemo } from 'react';

// Formato colones (₡)
function formatCRC(value) {
  const n = Number(value || 0);
  return n.toLocaleString('es-CR', {
    style: 'currency',
    currency: 'CRC',
    minimumFractionDigits: 2,
  });
}

function maxOf(arr, key) {
  if (!Array.isArray(arr) || !arr.length) return 0;
  return arr.reduce((m, x) => Math.max(m, Number(x?.[key] || 0)), 0);
}

/**
 * Gráfica simple (sin librerías) con barras horizontales
 * items: [{name, value}]
 */
function SimpleBarChart({ title, items }) {
  const maxVal = useMemo(() => maxOf(items, 'value'), [items]);

  return (
    <div className="cg-card cg-card-inner">
      <div className="cg-card-title">{title}</div>

      {!items?.length ? (
        <div className="cg-muted">Sin datos</div>
      ) : (
        <div className="cg-bars">
          {items.map((it) => {
            const v = Number(it.value || 0);
            const pct = maxVal > 0 ? Math.max(2, Math.round((v / maxVal) * 100)) : 0;

            return (
              <div className="cg-bar-row" key={it.name}>
                <div className="cg-bar-label" title={it.name}>
                  {it.name}
                </div>
                <div className="cg-bar-track">
                  <div className="cg-bar-fill" style={{ width: `${pct}%` }} />
                </div>
                <div className="cg-bar-value">{it.displayValue}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function TopTable({ title, rows, mode }) {
  return (
    <div className="cg-card cg-card-inner">
      <div className="cg-card-title">{title}</div>

      {!rows?.length ? (
        <div className="cg-muted">Sin datos</div>
      ) : (
        <div className="cg-table-wrap">
          <table className="cg-table">
            <thead>
              <tr>
                <th>Cliente</th>
                <th style={{ width: 140, textAlign: 'right' }}>Pedidos</th>
                <th style={{ width: 200, textAlign: 'right' }}>Ingresado</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={`${mode}-${r.name}`}>
                  <td>{r.name}</td>
                  <td style={{ textAlign: 'right' }}>{r.ordersCount}</td>
                  <td style={{ textAlign: 'right' }}>{formatCRC(r.moneyTotal)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default function TopClients({ data }) {
  const topByOrders = data?.topClients?.topByOrders || [];
  const topByMoney = data?.topClients?.topByMoney || [];

  const chartOrdersItems = useMemo(() => {
    return topByOrders.map((x) => ({
      name: x.name,
      value: Number(x.ordersCount || 0),
      displayValue: `${x.ordersCount || 0}`,
    }));
  }, [topByOrders]);

  const chartMoneyItems = useMemo(() => {
    return topByMoney.map((x) => ({
      name: x.name,
      value: Number(x.moneyTotal || 0),
      displayValue: formatCRC(x.moneyTotal || 0),
    }));
  }, [topByMoney]);

  return (
    <div className="cg-section">

      <div className="cg-grid-2">
        <SimpleBarChart title="Top 5 por número de pedidos" items={chartOrdersItems} />
        <SimpleBarChart title="Top 5 por dinero ingresado" items={chartMoneyItems} />
      </div>

      <div className="cg-grid-2">
        <TopTable title="Tabla (Top por pedidos)" rows={topByOrders} mode="orders" />
        <TopTable title="Tabla (Top por dinero)" rows={topByMoney} mode="money" />
      </div>
    </div>
  );
}
